import React, {Component} from 'react';
import PropTypes from 'prop-types';

class MenuCascadeIcon extends Component {
  render() {
    return (
      <div className={this.props.className}>
        <svg
          width="6px"
          height="10px"
          viewBox="0 0 6 10"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
        >
          <defs>
            <polygon
              id="menuCascadeIcon"
              points="9.76 16.5 9.76 7.5 14.2388732 11.9788732"
            ></polygon>
          </defs>
          <g
            id="Style-Guide"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
          >
            <g
              id="Blaize-Studio---Icons"
              transform="translate(-853.000000, -4359.000000)"
            >
              <g id="General-Icons" transform="translate(56.000000, 753.000000)">
                <g id="row" transform="translate(0.000000, 3561.000000)">
                  <g id="Icon" transform="translate(641.000000, 0.000000)">
                    <g
                      id="general-/-menu_cascade-/-Default"
                      transform="translate(147.000000, 38.000000)"
                    >
                      <rect id="Container" x="0" y="0" width="24" height="24"></rect>
                      <mask id="mask-2" fill="white">
                        <use xlinkHref="#menuCascadeIcon"></use>
                      </mask>
                      <use
                        id="menu_cascade"
                        fill="currentColor"
                        xlinkHref="#menuCascadeIcon"
                      ></use>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </svg>
      </div>
    );
  }
}

MenuCascadeIcon.propTypes = {
  className: PropTypes.string,
};

export default MenuCascadeIcon;
